import { Record } from 'immutable';

const ExteriorColourPhotoRecord = Record({
    code: '', // 25D
    description: '', // Snowflake White Pearl
    tile: '', // 2011-suzuki-Blanc-neige-nacre.jpg
    front: '', // ca/2021/mazda/3-sport/100th/5-doors-hatchback/exteriorColors/13520_cc0640_001_25d.png
    side: '', // ca/2021/mazda/3-sport/100th/5-doors-hatchback/exteriorColors/13520_cc0640_032_25d.png
    rear: '', // ca/2021/mazda/3-sport/100th/5-doors-hatchback/exteriorColors/13520_cc0640_014_25d.png
});

class ExteriorColourPhotoModelV25 extends ExteriorColourPhotoRecord {}

export default ExteriorColourPhotoModelV25;
